import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { CREATE_KKM } from './types';

export const createKkm = createTaskAction(CREATE_KKM);
